import React, { useEffect } from "react";
import { ModalProps, Modal, Button } from "@blacknut/react-sdk";
import { QRCodeSVG } from "qrcode.react";
import { Theme } from "src/theme/Theme";
import styles from "./styles.module.scss";
import { QRCodeConfig } from "src/utils/QRCodeConfig";
import { logD } from "@blacknut/logging/dist";
import { LOGGING_TAG } from "src/utils/Utils";

interface QRCodeModalProps extends ModalProps {
  onClose: () => void;
  title: string;
  description: string;
  btnText: string;
  URL?: string;
  theme: Theme;
  headerElement?: JSX.Element;
}

export const QRCodeModal = (props: QRCodeModalProps) => {
  const { onClose, title, description, btnText, URL, theme, headerElement } = props;

  useEffect(() => {
    logD(LOGGING_TAG, "Using url: %o", URL);
  }, [URL]);

  return (
    <Modal
      testID="modalTV"
      className={styles.QRCodeModal}
      {...props}
      title={undefined}
      addButtons={false}
    >
      {headerElement}
      <div className={styles.message}>
        <div className={styles.left}>
          <div>
            <div className={styles.title}>{title}</div>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </div>
          <Button
            variant="primary"
            key="cancel"
            className={styles.notNow}
            onClick={onClose}
          >
            {btnText}
          </Button>
        </div>
        {URL && (
          <div className={styles.right}>
            <QRCodeSVG
              value={URL}
              size={QRCodeConfig.default}
              marginSize={theme.name === "dark" ? 4 : 0}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
